// extracted by mini-css-extract-plugin
export default {"root":"TimeCounter_root__Zc+Wk","rootTypeRight":"TimeCounter_rootTypeRight__pfHAP"};